<template>
    <div class="row form-group">
        <button class="btn btn-primary form-group" type="button" style="padding-left:12px">
            <span>{{ $t("Lbl_EMPBE_GetVerificationCode") }}</span></button>
        <textbox :placeholder="$t('lbl_emp2_VerificationCode')" type="number"></textbox>
    </div>
</template>
<script>
import textbox from './textbox.vue';
export default {
    components:{
        textbox
    }
}
</script>